import values from 'lodash/values';

const defaultInitialState = {
	columns: {
		date: {
			index: 'date',
			title: 'Date'
		},
		manager: {
			index: 'manager',
			title: 'Manager'
		},
		country: {
			index: 'country',
			title: 'Country',
			className: 'padding-0-15'
		},
		offer: {
			index: 'offer',
			title: 'Offer',
			className: 'long'
		},
		affiliate_id: {
			index: 'affiliate_id',
			title: 'Affiliate id'
		},
		total: {
			index: 'approved',
			title: 'Approved',
			className: 'padding-0-15'
		},
		approved: {
			index: 'total',
			title: 'Total'
		},
		payouts: {
			index: 'payouts',
			title: 'Payouts (by approved conversions/default)',
			className: 'padding-0-15 long'
		},
		comment: {
			index: 'comment',
			title: 'Comment',
			className: 'long'
		}
	},
	isToggledStartFrom10Approves: false
};

const TOGGLE_START_FROM_10_APPROVES = 'traffic-accounting/DROP_TABLE/TOGGLE_START_FROM_10_APPROVES';

const createTable = ({
	namespace,
	stateNodeName
}) => {

	// initState
	const initialState = {
		...defaultInitialState
	};

	// actions
	const actions = {
		toggleStartFrom10Approves: () => ({ type: TOGGLE_START_FROM_10_APPROVES })
	};

	// reducers
	const reducers = {
		[TOGGLE_START_FROM_10_APPROVES]: (state, action) => ({
			...state,
			[stateNodeName]: {
				...state[stateNodeName],
				isToggledStartFrom10Approves: !state[stateNodeName].isToggledStartFrom10Approves
			}
		})
	};

	// selectors
	const selectors = {
		getTable: state => {
			const { data } = state[namespace];
			const table = state[namespace][stateNodeName];

			return {
				headers: values(table.columns),
				rows: data && data.result,
				cols: data && data.columns
			};
		},
		getIsToggledStartFrom10Approves: state => state[namespace][stateNodeName].isToggledStartFrom10Approves
	};

	return {
		initialState,
		selectors,
		actions,
		reducers
	};
};

export default createTable;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/traffic-accounting/components/table-drop/index.js